module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDIwIDE3Ij4KICA8cGF0aCBpZD0iSWNvbiIgZD0iTTczMy0zMjh2LTZoNHY2aDV2LThoM2wtMTAtOS0xMCw5aDN2OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MjUgMzQ1KSIgZmlsbD0iI2Q5ZDlkOSIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/home.svg
// module id = 1021
// module chunks = 37